var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 48,
    viewBox: "0 0 69 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6687 13.4196C20.7719 14.1996 20.7719 15.4596 21.6687 16.2396L30.5911 23.9996L21.6687 31.7596C20.7719 32.5396 20.7719 33.7996 21.6687 34.5796C22.5656 35.3596 24.0143 35.3596 24.9111 34.5796L35.4661 25.3996C36.363 24.6196 36.363 23.3596 35.4661 22.5796L24.9111 13.3996C24.0373 12.6396 22.5656 12.6396 21.6687 13.4196Z",
    fill: "#EB008D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3631 13.4196C33.4662 14.1996 33.4662 15.4596 34.3631 16.2396L43.2854 23.9996L34.3631 31.7596C33.4662 32.5396 33.4662 33.7996 34.3631 34.5796C35.2599 35.3596 36.7086 35.3596 37.6054 34.5796L48.1605 25.3996C49.0573 24.6196 49.0573 23.3596 48.1605 22.5796L37.6054 13.3996C36.7316 12.6396 35.2599 12.6396 34.3631 13.4196Z",
    fill: "#EB008D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/DoubleArrow.c6eacf709d58751764c41018b5c8c688.svg";
export { ForwardRef as ReactComponent };